import { Component, Input } from '@angular/core';

@Component({
  selector: 'bom-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() size: 'normal' | 'small' = 'normal';

  @Input()
  message?: string;
}
